import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { COLORS } from '../constants';
import { MaterialIcons } from '@expo/vector-icons';
import { CommonActions } from '@react-navigation/native';
import * as Sharing from 'expo-sharing';


import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';

export default function ProfileMiniMenu(props) {

  const navigation = useNavigation();

  const handleReset = () => {
    AsyncStorage.clear();

    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          {name: 'Welcome' },
          {name: 'Profile' },
        ],
      })
    );
  };

  const handleRestore = () => {
    console.log("restore");

    // const [data, setData] = useState([]);
    // async function getData() {
    //   fetch(
    //     "https://raw.githubusercontent.com/Forschung/AmbeentData/main/modems.json"
    //   )
    //     .then(function (response) {
    //       return response.text();
    //     })
    //     .then(function (txt) {
    //       let d = txt.replace(/Brand/g, `"Brand"`);
    //       d = d.replace(/Model/g, `"Model"`);
    //       d = JSON.parse(d);
    //       setData(d);
    //     });
    }

  const handleBackup = () => {
    console.log("backup: ", Sharing.isAvailableAsync());
    // let url = '../../json/profile.json';
    // let messageText = 'Text that you want to share goes here';
    // const options = {
    //    mimeType: 'application/json',
    //    dialogTitle: messageText,
    // };
    // Sharing.shareAsync(url, options);

  };


  return (
    <View style={styles.wrapper}>
      {/* <TouchableOpacity
        style={styles.btnWrapper}
        onPress={() => { handleRestore() }}
      >
        <View style={styles.btn}>
          <MaterialIcons name="file-download" size={24} color={COLORS.accent} />
        </View>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.btnWrapper}
        onPress={() => { handleBackup() }}
      >
        <View style={styles.btn}>
          <MaterialIcons name="file-upload" size={24} color={COLORS.light} />
        </View>
      </TouchableOpacity> */}

      <TouchableOpacity
        style={styles.btnWrapper}
        onPress={() => { handleReset() }}
      >
        <View style={styles.btn}>
          <MaterialIcons name="delete-forever" size={24} color={COLORS.error} />
        </View>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  btnWrapper: {
    padding: 5,
  },
  btn: {
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
  }
})